module.exports = __webpack_public_path__ + "img/product-preview-29.c1f4f28.png";